import { render, staticRenderFns } from "./BoletoHistory.vue?vue&type=template&id=a2be20fa&"
import script from "./BoletoHistory.vue?vue&type=script&lang=js&"
export * from "./BoletoHistory.vue?vue&type=script&lang=js&"
import style0 from "./BoletoHistory.vue?vue&type=style&index=0&escoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDataTable,VTooltip})
